import Vue from 'vue'
import router from '@/router'
import ContabilidadAsientosContableAPI from '@/api/contabilidad/asientoscontables'


//en contexto tenemos todo el objeto completo

export async function fetch_formas_de_pago(context) {
  try {
    // Comprobar si ya existen formas de pago en el estado
    if (context.state.formas_de_pago.length > 0) {
      return; // Si ya existen, salimos de la función
    }

    var url = `/comprobantes/formaDePago`;

    await Vue.axios({
      method: 'GET',
      url: url,
    }).then(response => {
      context.commit('SET_FORMAS_DE_PAGO', response.data);
    });
  } catch (error) {
    console.error("Error al obtener formas de pago:", error);
  }
}

export async function fetch_formas_de_pago_para_cobro(context) {
  try {
    // Comprobar si ya existen formas de pago en el estado
    if (context.state.formas_de_pago_para_cobro.length > 0) {
      return; // Si ya existen, salimos de la función
    }

    var url = `/comprobantes/formasdepago/cobro`;

    await Vue.axios({
      method: 'GET',
      url: url,
    }).then(response => {
      context.commit('SET_FORMAS_DE_PAGO_PARA_COBRO', response.data);
    });
  } catch (error) {
    console.error("Error al obtener formas de pago:", error);
  }
}



export async function get_total_ventas_blanco(context) {

  try {
    var url = `/comprobantes/ventas/blanco`;

    await Vue.axios({
      method: 'GET',
      url: url,
    }).then(response => {
      context.commit('SET_MONTO_VENTAS_BLANCO', response.data)
    })
  } catch (error) {

  }
}

export function fetch_asientos_contables(
  context,
  // El payload es opcional: registrar/eliminar/actualizar refrescan la lista
  // sin pasarlo, y desestructurar undefined tiraba un TypeError que la cadena
  // del .then convertía en un error de guardado aunque el asiento se hubiera
  // creado bien.
  { paginacion = { page: 1, rowsPerPage: 10 }, dateFilter, uuid_sucursal } = {}
) {
  return new Promise((resolve, reject) => {

    let queryString = dateFilter || "";

    if (uuid_sucursal) {
      queryString += `&uuid_sucursal=${uuid_sucursal}`;
    }
    
    ContabilidadAsientosContableAPI.index(paginacion, queryString)
      .then((response) => {
        context.commit("SET_ASIENTOS_CONTABLES", response.data.results);
        resolve(response);
      })
      .catch((e) => reject(e));
  });
}



// Refresca la lista después de un alta/baja/edición. Es un efecto secundario:
// si falla, la operación que ya respondió OK igual fue exitosa.
function refrescarAsientos(context) {
  Promise.resolve()
    .then(() => context.dispatch("fetch_asientos_contables"))
    .catch((e) => console.error("No se pudo refrescar la lista de asientos:", e));
}

// Método para buscar un asiento contable por número
export async function buscarAsientoContable(context, numeroAsiento) {
  try {
    const response = await ContabilidadAsientosContableAPI.show(numeroAsiento);

    // Actualiza el estado con el asiento contable encontrado
    context.commit('SET_ASIENTO_CONTABLE', response.data);
  } catch (error) {
    console.error('Error al buscar el asiento contable:', error);
    // Puedes manejar errores aquí según sea necesario
  }
}

/**
 * Devuelve un asiento por su número. `buscarAsientoContable` se traga el error
 * y sólo deja el resultado en el store, que le sirve al buscador; la pantalla
 * de edición necesita el asiento en la mano y enterarse si no existe.
 */
export async function obtener_asiento_contable(context, numeroAsiento) {
  const response = await ContabilidadAsientosContableAPI.show(numeroAsiento);
  return response.data;
}

export async function registrar_asiento_contable(context, data) {
  return new Promise((resolve, reject) => {
    console.log("registrar_asiento_contable", data);

    ContabilidadAsientosContableAPI.create(data).then(response => {

      refrescarAsientos(context);
      console.log("registrar_asiento_contable response", response);

      resolve(response);
    }).catch(e => {
      console.log("registrar_asiento_contable error", e);

      reject(e);
    })
  })

}
export function eliminar_asiento_contable(context, data) {
  return new Promise((resolve, reject) => {
    ContabilidadAsientosContableAPI.delete(data).then(response => {
      refrescarAsientos(context);
      resolve(response);
    }).catch(e => {
      reject(e);
    })
  })

}
export function actualizar_asiento_contable(context, data) {
  return new Promise((resolve, reject) => {
    ContabilidadAsientosContableAPI.update(data).then(response => {
      refrescarAsientos(context);
      resolve(response);
    }).catch(e => {
      reject(e);
    })
  })

}

export function togglePrecioVentaManual({ commit }, value) {
  commit("SET_PRECIO_VENTA_MANUAL", value);
}